import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InconformidadePage } from './inconformidade.page';
import { bindActionCreators } from 'redux';
import * as commonActions from '../common.action';
import WebapiCommon from '../util/webapi.common';
import {
  LOCAL_STORAGE_IMPRESSORA_LAUDO,
  getImpressoraLaudoDefault,
} from '../../../localStorage.util';
import cloneDeep from 'lodash/cloneDeep';
import { editorUrl } from '../../../constants/defaultValues';

class InconformidadeContainer extends Component {
  constructor() {
    super();
    this.state = {
      nConformidadeId: undefined,
      impeditiva: false,
      justificativa: undefined,
      observacao: null,
      exibirNaoConformidadeNoLaudo: false,
      openModal: false,
      nConf: null,
      bloquearImprimir: false,
      listaNConf: [],
      openModalImprmirConsolidado: false,
      openModalImprimirIndividual: false,
      impressoras: [],
      impressora: null,
      itensCheckboxNConf: [],
      nConfIdTermo: null,
      termoNConfConsolidado: {
        paciente: '',
        registro: '',
        rg: '',
        leito: '',
        nConf: [],
        nConfAndTexto: {nConf: '', texto: '',  observacao: '' },
        listaNaoConformidades: [],
        dadosGeraisHospital: {
          localAndData: '',
          logoBase64: '',
        },
      },
    };
  }

  componentDidMount() {
    const preencherlistagemselect = new Promise((resolve) => {
      if (this.props.inconformidade.length === 0) {
        WebapiCommon.getNaoConformidades().then((naoconformidades) => {
          this.props.commonActions.preencherNaoConformidades(naoconformidades);
          resolve();
        });
      } else {
        resolve();
      }
    });

    const preencherhistorico = new Promise((resolve) => {
      if (this.props.historico.length === 0) {
        WebapiCommon.getHistoricoNaoConformidades(
          this.props.detalhes.laudo
        ).then((historico) => {
          this.props.commonActions.preenhcerHistoricoInconformidades(historico);
          resolve();
        });
      } else {
        resolve();
      }
    });

    // const getImpressoras = new Promise((resolve) => {
    //   WebapiCommon.getImpressoras().then((response) => {
    //     let impressora = getImpressoraLaudoDefault();
    //     this.setState({
    //       impressoras: response,
    //       impressora: JSON.parse(impressora),
    //     });

    //     resolve();
    //   });
    // });

    this.props.commonActions.showFadeCarregando(true);

    Promise.all([
      preencherlistagemselect,
      preencherhistorico,
      // getImpressoras,
    ]).then(() => {
      this.props.commonActions.showFadeCarregando(false);
    });
  }

  render() {
    return (
      <InconformidadePage
        intl={this.props.intl}
        usuario={this.props.usuario}
        naoconformidades={this.getNaoconformidades()}
        bloquearImprimir={this.state.bloquearImprimir}
        historico={this.props.historico}
        onChange={this.onChange.bind(this)}
        onClick={this.adicionarNaoConformidade.bind(this)}
        setJustificativa={this.setJustificativa.bind(this)}
        resolverNaoConformidade={this.resolverNaoConformidade.bind(this)}
        loading={this.loading.bind(this)}
        exibirNaoConformidadeNoLaudo={this.state.exibirNaoConformidadeNoLaudo}
        exibirNaoConformidadeNoLaudoChangeValor={this.exibirNaoConformidadeNoLaudoChangeValor.bind(
          this
        )}
        existeJustificativa={this.existeJustificativa.bind(this)}
        atualizarExibicaoNaoConformidadeNoTextoFinalLaudo={this.atualizarExibicaoNaoConformidadeNoTextoFinalLaudo.bind(
          this
        )}
        altura={this.props.altura}
        openModal={this.state.openModal}
        toggleModal={this.toggleModal.bind(this)}
        nConformidadeId={this.state.nConformidadeId}
        observacao={this.state.observacao}
        modalOnChangeTexto={this.modalOnChangeTexto.bind(this)}
        nConf={this.state.nConf}
        listaNConf={this.state.listaNConf}
        adicionarNConfNaLista={this.adicionarNConfNaLista.bind(this)}
        openModalImprmirConsolidado={this.state.openModalImprmirConsolidado}
        openModalImprimirIndividual={this.state.openModalImprimirIndividual}
        toggleModalImprmirConsolidado={this.toggleModalImprmirConsolidado.bind(
          this
        )}
        toggleModalImprimirIndividual={this.toggleModalImprimirIndividual.bind(
          this
        )}
        atualizarImpressora={this.atualizarImpressora.bind(this)}
        impressoras={this.state.impressoras}
        selecaoItemCheckbox={this.selecaoItemCheckbox.bind(this)}
        itemCheckboxIsSelecionado={this.itemCheckboxIsSelecionado.bind(this)}
        imprimirTermoAnuencia={this.imprimirTermoAnuencia.bind(this)}
        impressora={this.state.impressora}
        itensCheckboxNConf={this.state.itensCheckboxNConf}
        imprimirTermoIndividual={this.imprimirTermoIndividual.bind(this)}
        removerItemListaNConf={this.removerItemListaNConf.bind(this)}
        termoNConfConsolidado={this.state.termoNConfConsolidado}
        onload={this.onload}
        limparTermoNConfIndividual={this.limparTermoNConfIndividual.bind(this)}
      />
    );
  }

  toggleModal() {
    this.setState((state) => ({
      openModal: !state.openModal,
      listaNConf: [],
      nConf: null,
      observacao: '',
      exibirNaoConformidadeNoLaudo: false,
    }));
  }
  exibirNaoConformidadeNoLaudoChangeValor(event) {
    this.setState({
      exibirNaoConformidadeNoLaudo: event.currentTarget.checked,
    });
  }

  loading(loading) {
    this.props.commonActions.showFadeCarregando(loading);
  }

  getNaoconformidades() {
    let array = [];
    this.props.inconformidade.map((item) => {
      return array.push({
        label: item.label,
        value: item.value,
        imprimir: item.imprimir === 'S',
        impeditiva: item.impeditiva === 'S',
      });
    });

    return array;
  }

  onChange(event) {
    this.setState({
      nConformidadeId: event.value,
      impeditiva: event.impeditiva,
      nConf: event,
    });

    if (event.imprimir) {
      this.setState({
        exibirNaoConformidadeNoLaudo: true,
        bloquearImprimir: true,
      });
    } else {
      this.setState({
        exibirNaoConformidadeNoLaudo: false,
        bloquearImprimir: false,
      });
    }
  }

  modalOnChangeTexto(event) {
    this.setState({
      observacao: event.currentTarget.value,
    });
  }

  adicionarNaoConformidade(event) {
    this.props.commonActions.showFadeCarregando(true);
    let { listaNConf } = this.state;
    let nConfRequest = [];
    let imprimirTermoConsolidado = event.currentTarget.name === 'imprimir';

    listaNConf.forEach((el) =>
      nConfRequest.push({
        nConfId: el.value,
        exameId: this.props.detalhes.exameId,
        etapa: this.props.etapa,
        exibidaNoTextoFinalLaudo: el.exibirNaoConformidadeNoLaudo,
        observacao: el.observacao,
      })
    );

    WebapiCommon.registrarNaoConformidade(
      this.props.detalhes.laudo,
      nConfRequest
    ).then(() => {
      Promise.all([
        WebapiCommon.getHistoricoNaoConformidades(this.props.detalhes.laudo),
        WebapiCommon.getTotalNaoConformidades(this.props.detalhes.laudo),
      ]).then((resultado) => {
        this.props.commonActions.preenhcerHistoricoInconformidades(
          resultado[0]
        );
        this.props.commonActions.preencherTotalNaoConformidades(resultado[1]);

        WebapiCommon.obterStatusEtapasLaudo(this.props.detalhes.laudo).then(
          (etapas) => {
            this.props.commonActions.atualizarStatusDasEtapasDoLaudo(
              etapas,
              this.props.detalhes.laudo
            );
          }
        );

        this.atualizarListagem('naoconformidade');
        this.props.commonActions.atualizarPropriedadeNoItemDaLista(
          this.props.detalhes.laudo,
          'existeNConfPendente',
          true
        );

        this.props.commonActions.showFadeCarregando(false);
        this.toggleModal();
        this.props.commonActions.showAlerta(
          'sucesso',
          'Inconformidade Adicionada',
          1500
        );

        if (imprimirTermoConsolidado) {
          this.toggleModalImprmirConsolidado();
        }
      });
    });
  }

  setJustificativa(justificativa) {
    this.setState({
      justificativa: justificativa,
    });
  }

  existeJustificativa() {
    if (
      this.state.justificativa &&
      this.state.justificativa !== null &&
      this.state.justificativa !== ''
    ) {
      return true;
    } else {
      return false;
    }
  }

  atualizarExibicaoNaoConformidadeNoTextoFinalLaudo(idNConfoHist, exibir) {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.atualizarSnImprimirNConformidadeNoLaudo(
      idNConfoHist,
      exibir
    ).then(() => {
      WebapiCommon.getHistoricoNaoConformidades(this.props.detalhes.laudo).then(
        (historico) => {
          this.props.commonActions.preenhcerHistoricoInconformidades(historico);
          this.props.commonActions.showFadeCarregando(false);
        }
      );
    });
  }

  resolverNaoConformidade(id) {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.resolverNaoConformidade(id, this.state.justificativa).then(
      (resolverNConformidadeResponse) => {
        WebapiCommon.getHistoricoNaoConformidades(
          this.props.detalhes.laudo
        ).then((historico) => {
          WebapiCommon.obterStatusEtapasLaudo(this.props.detalhes.laudo).then(
            (etapas) => {
              this.props.commonActions.atualizarStatusDasEtapasDoLaudo(
                etapas,
                this.props.detalhes.laudo
              );
              this.props.commonActions.preenhcerHistoricoInconformidades(
                historico
              );
              this.props.commonActions.atualizarPropriedadeNoItemDaLista(
                this.props.detalhes.laudo,
                'existeNConfPendente',
                resolverNConformidadeResponse.existeNConfPendente
              );
              this.atualizarDetalhes(false, false);
              this.props.commonActions.showFadeCarregando(false);
              this.props.commonActions.showAlerta(
                'sucesso',
                'Inconformidade Resolvida!',
                1500
              );
            }
          );
        });
      }
    );
  }

  getDadosRelatorioNaoConformidade() {
    const emAberto = this.props.historico.filter((item) => {
      return item.resolucao === '';
    });

    const inclusao = emAberto.length > 0 ? emAberto[0].inclusao : '';

    const descricao = emAberto.length > 0 ? emAberto[0].descricao : '';

    return {
      laudo: this.props.detalhes.laudo,
      dataInclusao: inclusao,
      medicoSolicitante: this.props.detalhes.medico,
      crmMedicoSolicitante: 0,
      nomePaciente: this.props.detalhes.paciente,
      nrExame: this.props.detalhes.nrExame,
      cartaoSUS: 0,
      prontuario: this.props.detalhes.prontuario,
      dataRecebimento: this.props.detalhes.dataEntradaMaterial,
      tipoExame: this.props.detalhes.exame,
      atendimento: this.props.detalhes.laudo,
      naoConformidade: descricao,
    };
  }

  existeNaoConformidadeEmAberto() {
    const emAberto = this.props.historico.filter((item) => {
      return item.resolucao === '';
    });

    return emAberto.length >= 1;
  }

  fecharDetalhes() {
    this.props.funcFechar();
  }

  atualizarListagem(status) {
    let listagem = [...this.props.listagem];
    const listagemIndex = listagem.findIndex(
      (item) => item.laudo === this.props.detalhes.laudo
    );
    const item = listagem[listagemIndex];
    const etapaIndex = item.etapas.findIndex(
      (item) => item.etapa === this.props.etapa
    );
    listagem[listagemIndex].etapas[etapaIndex].status = status;
    this.props.commonActions.preencherListagem(listagem);
  }

  atualizarDetalhes(existeNConf, impeditiva) {
    let detalhes = { ...this.props.detalhes };
    let etapa = detalhes.etapas.find((item) => item.etapa === this.props.etapa);

    if (etapa.etapa === 'MATERIAL') {
      detalhes.naoConformidadeImpeditivaMaterial = impeditiva;
      detalhes.naoConformidadeMaterial = existeNConf;
    }

    this.props.commonActions.atualizarDetalhes(detalhes);
  }

  adicionarNConfNaLista = () => {
    let {
      listaNConf,
      nConf,
      observacao,
      exibirNaoConformidadeNoLaudo,
    } = this.state;

    if (listaNConf.findIndex((s) => s.value === nConf.value) === -1) {
      listaNConf.push({
        label: nConf.label,
        value: nConf.value,
        observacao,
        exibirNaoConformidadeNoLaudo,
      });

      this.setState({
        listaNConf,
        nConf: null,
        observacao: '',
        exibirNaoConformidadeNoLaudo: false,
      });
    }
  };

  toggleModalImprmirConsolidado = () =>
    this.setState((state) => ({
      openModalImprmirConsolidado: !state.openModalImprmirConsolidado,
      itensCheckboxNConf: this.props.historico.map((el) => el.nConfId),
    }));

  toggleModalImprimirIndividual = (nConfIdTermo) =>
    this.setState((state) => ({
      openModalImprimirIndividual: !state.openModalImprimirIndividual,
      nConfIdTermo: nConfIdTermo,
    }));

  atualizarImpressora = (impressora) => {
    localStorage.setItem(
      LOCAL_STORAGE_IMPRESSORA_LAUDO,
      JSON.stringify(impressora)
    );
    this.setState({
      impressora: impressora,
    });
  };

  selecaoItemCheckbox = (id) => {
    let { itensCheckboxNConf } = this.state;

    if (this.itemCheckboxIsSelecionado(id)) {
      itensCheckboxNConf = itensCheckboxNConf.filter((el) => el !== id);
    } else {
      itensCheckboxNConf.push(id);
    }

    this.setState({
      itensCheckboxNConf,
    });
  };

  itemCheckboxIsSelecionado = (id) => {
    let { itensCheckboxNConf } = this.state;
    return itensCheckboxNConf.indexOf(id) > -1;
  };

  imprimirTermoAnuencia = () =>
    new Promise((resolve) => {
      this.props.commonActions.showFadeCarregando(true);
      let { /* impressora */ itensCheckboxNConf } = this.state;
      let laudo = this.props.detalhes.laudo;

      WebapiCommon.imprimirTermoAnuencia(laudo, itensCheckboxNConf, true).then(
        (response) => {
          let detalhes = { ...this.props.detalhes };
          detalhes.termoAnuenciaImpresso = response;
          this.props.commonActions.atualizarDetalhes(detalhes);
          this.setState({ termoNConfConsolidado: response });
          this.atualizarTermoNConfImpressoItemListagem();
          resolve();
        }
      );
    });

  imprimirTermoIndividual = (nConfIdTermo) =>
    new Promise((resolve) => {
      this.props.commonActions.showFadeCarregando(true);
      let laudo = this.props.detalhes.laudo;
      let itensCheckboxNConf = [nConfIdTermo];

      WebapiCommon.imprimirTermoAnuencia(laudo, itensCheckboxNConf, false).then(
        (response) => {
          let detalhes = { ...this.props.detalhes };
          detalhes.termoAnuenciaImpresso = response;
          this.props.commonActions.atualizarDetalhes(detalhes);
          this.atualizarTermoNConfImpressoItemListagem();
          this.setState({ termoNConfConsolidado: response });
          resolve();

          // if (response.nConfAndTexto.texto.length > 0) {
          //   fetch(`${editorUrl}/Editor/ConvertRtfToHtml`, {
          //     headers: {
          //       Accept: 'application/json',
          //       'Content-Type': 'application/json',
          //     },
          //     method: 'POST',
          //     body: JSON.stringify({ text: response.nConfAndTexto.texto }),
          //   })
          //     .then((r) => r.json())
          //     .then((res) => {
          //       response.nConfAndTexto.texto = res;

          //       this.setState({ termoNConfConsolidado: response });

          //       setTimeout(resolve, 1000);
          //     });
          // } else {
          //   this.setState({ termoNConfConsolidado: response });
          //   resolve();
          // }
        }
      );
    });

  removerItemListaNConf = (value) => {
    let { listaNConf } = this.state;
    let indexOf = listaNConf.findIndex((el) => el.value === value);

    if (indexOf > -1) {
      listaNConf.splice(indexOf, 1);
    }

    this.setState({
      listaNConf,
    });
  };

  loading = (showCarregando) =>
    this.props.commonActions.showFadeCarregando(showCarregando);

  limparTermoNConfIndividual = () =>
    this.setState({
      termoNConfConsolidado: {
        paciente: '',
        registro: '',
        rg: '',
        leito: '',
        nConf: [],
        nConfAndTexto: {nConf: '', texto: '', observacao: ''},
        listaNaoConformidades: [],
        dadosGeraisHospital: {
          localAndData: '',
          logoBase64: '',
        },
      },
    });

  onload = (obj) => {
    let divdetalhes = document.getElementsByClassName(
      'mv-detalhes-container'
    )[0];
    let altura = divdetalhes !== undefined ? divdetalhes.scrollHeight : 0;

    obj.currentTarget.style.height =
      obj.currentTarget.contentDocument.body.scrollHeight -
      (altura - 36) +
      'px';
  };

  atualizarTermoNConfImpressoItemListagem = () => {
    let listagem = cloneDeep(this.props.listagem);
    let index = listagem.findIndex(
      (item) => item.laudo === this.props.detalhes.laudo
    );

    if (index > -1) {
      listagem[index].termoNConfImpresso = true;
      this.props.commonActions.preencherListagem(listagem);
    }
  };
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    inconformidade: state.commonReducer.inconformidades,
    historico: state.commonReducer.historicoInconformidades,
    detalhes: state.commonReducer.detalhes,
    listagem: state.commonReducer.listagem,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InconformidadeContainer);



// WEBPACK FOOTER //
// ./src/app/common/inconformidade/inconformidade.container.js